<template>
  <div class="container">
    <h1>Urvalssortering</h1>
<p>Tidskomplexitet i värsta fall: O(n<sup>2</sup>)<br>
    Tidskomplexitet i bästa fall: O(n<sup>2</sup>)</p>
    <div id="sifferfält">
    <div class="utanförSiffra" v-for="(item, index) in lista" :key="index">

    <div class="sifferbehållare" :style="'left:'+(index*85)+'px;top:100px;'">
       <div class="siffra" :id="index" >
           {{ item }}
       </div>

   </div>


   <!--
   <div class="i">i</div>
   <div class="n">n</div>  -->
<div class="index-nummer" :style="'left:'+(index*85+40)+'px;top:190px;'">[{{index}}]</div>
</div>

<div id="i-pos"><br><b>i</b></div>
<div id="j-pos">mindre?</div>
<div id="min-pos">minst</div>

</div>

<div id="klart" style="color:black;"><b>Listan är sorterad</b></div>

<br><br>


<!--button v-on:click="sortera2()">Bubbel-Sortera manuellt</button-->
<div id="knapprad">
<button v-on:click="auto()">&#9654;</button>

<button v-on:click="pause()"> &#9208; </button>

<button v-on:click="blanda()">Blanda</button>
</div>

<br>
<div id="kodfält">

public void Urvalssortering (int [] lista)<br>
{<br>
     {{'\xa0 \xa0'}}int length = lista.Length;<br><br>

     {{'\xa0 \xa0'}}for ( int i =0; i n&#60; length -1; i++) <br>
     {{'\xa0 \xa0'}}{<br>
     {{'\xa0 \xa0 \xa0 \xa0'}}int min = i;<br>

     {{'\xa0 \xa0 \xa0 \xa0'}}for (int j = i + 1; j &#60; lenght; j++ ) <br>
     {{'\xa0 \xa0 \xa0 \xa0'}}{<br>
    {{'\xa0 \xa0 \xa0 \xa0 \xa0 \xa0'}}if (lista[j] &#60; lista[min];<br>
    {{'\xa0 \xa0 \xa0 \xa0 \xa0 \xa0'}}{<br>
    {{'\xa0 \xa0 \xa0 \xa0 \xa0 \xa0 \xa0 \xa0'}}min = j;<br>
    {{'\xa0 \xa0 \xa0 \xa0 \xa0 \xa0'}}}<br>
    {{'\xa0 \xa0 \xa0 \xa0'}}}<br><br>
    {{'\xa0 \xa0 \xa0 \xa0'}}int temp = lista[min];<br>
    {{'\xa0 \xa0 \xa0 \xa0'}}lista[min]=lista[i];<br>
    {{'\xa0 \xa0 \xa0 \xa0'}}lista[i] = temp;<br>
    {{'\xa0 \xa0'}}}<br>
}<br>


</div>


  </div>


</template>

<script>
export default {
  name: 'Urvalssortering',
  props: {
    msg: String,
    lista : Array
    //n:Number,
    //m:Number //lista.length-1
},
data() {
    return {
        min:0,
        i:0,
        j:1,
        lenght:7, //arrayens längd
        temp:0,
        sune:Function,
        tempBehållare:Object,
        höjd: Boolean,
        behövsUppdatera:Boolean,
        fas:0,
        påslaget:true
    }


},
methods: {
    sortera:function() {
        if (this.i>6) {//listan är sorterad
            document.getElementById('klart').style.display="block";
            clearInterval(this.sune);
            return;
        }


        if (this.j>=7) {

            var tempo = this.lista[this.min];
            this.lista[this.min]=this.lista[this.i];
            this.lista[this.i]=tempo;

            this.bytupp();
            this.bytPlats(this.i,this.min);
            this.körSekvens();



            this.i++;

            this.min=this.i;
            this.j=this.i+1;

            //this.fixaGrönt();
            return;
        }

        this.bytupp();

        if(this.lista[this.j]<this.lista[this.min]) {

            this.min= this.j;
            this.bytupp();
            this.j++;
            return
        }
        this.j++;

    },
    uppdateraVariabler:function() {
        for(var i = 0; i<7; i++) {
            document.getElementById("i-pos").style.left = (this.i*85 +40 ) + "px";
            document.getElementById("j-pos").style.left = (this.j*85 +40 ) + "px";
            document.getElementById("min-pos").style.left = (this.min*85 +40 ) + "px";
        }
    },


    uppdateraRad:function() {
        this.lista.forEach((item,i )=> {
            var temp= document.getElementById(i);
            temp.innerHTML=item;
            temp.parentElement.style.left=(i*85 + 'px');//kanske måste va med
            temp.parentElement.style.top='100px';//kanske måste va med


        })
        document.getElementById('i-pos').style.left=((42+this.i*85)+'px');
        if (this.i>6) document.getElementById('i-pos').style.display="none";
    },
    bytupp: function() {

            for (var i=0; i<7; i++) {
                var tempsak = document.getElementById(i);

                if (i == this.min) {
                    tempsak.parentElement.style.top="15px"

                } else {
                    tempsak.parentElement.style.top="100px"
                }

                if (i == this.j) { // ändrat för grönts skull
                    if (i>=this.i)
                    tempsak.parentElement.style.backgroundColor="#eee"
                    //tempsak.parentElement.style.backgroundColor="#dd2"
                } else {
                    if (i>=this.i)
                    tempsak.parentElement.style.backgroundColor="#bbb"
                }

            }
    },

    bytPlats: function(i,min) {
        var isak = document.getElementById(i);
        var minsak = document.getElementById(min);

        isak.parentElement.style.top="100px";
        isak.parentElement.style.left=(min*85)+'px';

        minsak.parentElement.style.top="100px";
        minsak.parentElement.style.left=(i*85)+'px';

    },

    taBortTransition: function(){
        for (var i=0; i<7;i++) {
            var tillf = document.getElementById(i);
            tillf.parentNode.style.transition="none";
        }
    },
    sättDitTransition: function(){
        for (var i=0; i<7;i++) {
            var tillf = document.getElementById(i);
            tillf.parentNode.style.transition="left 0.5s, top 0.5s";
        }
    },
    körSekvens:function() {

        var that= this;
        clearInterval(this.sune);

        setTimeout(function(){
            //that.bytPlats(that.i,that.min);
        }, 10);

        setTimeout(function(){
            that.taBortTransition();
        }, 500);

        setTimeout(function(){
            that.uppdateraRad();
        }, 1000);

        setTimeout(function(){
            that.sättDitTransition();
        }, 1500);


        setTimeout(function(){
            that.auto();
        }, 1000);




    },
    fixaGrönt: function() {
        /*for (var i=0; i<7;i++) {
            var tillf = document.getElementById(i);
            if(this.i>i) tillf.parentNode.style.backgroundColor="green";
        }*/
    },

    blanda:function() {
        document.getElementById('klart').style.display="none";
        this.j=1;//ska va 1
        this.i=0;
        this.min=0;
        document.getElementById('i-pos').style.left="25px";
        document.getElementById('i-pos').style.display="block";
        this.lista.forEach((item,i )=> {
            this.lista[i]= Math.floor(Math.random() * 100);
            var temp= document.getElementById(i);
            temp.innerHTML=this.lista[i];

        })

    },

    pause: function() {
        clearInterval(this.sune);
    },
    auto: function() {

        var that=this;
        this.sune = setInterval(function() {
            that.sortera()}, 1000);
    }
},
created() {
    document.title = 'Urvalssortering';
},
mounted() {
    this.blanda();
    this.uppdateraVariabler();
    this.behövsUppdatera=false;

},


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  margin: 0px;
  padding: 10px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.sifferbehållare {
    position: absolute;
    border-radius: 50px;
    /*background-color: #bb0;*/
    background-color: #bbb;
    border-style: solid;
    ddisplay: inline-block;
    height: 80px;
    width: 80px;
    transition: left 0.5s, top 0.5s;
}

#sifferfält {

    position: relative;
    display: inline-block;

    width: 600px;
    dheight: 220px;
    height: 200px;
    margin-bottom: 50px;
}

.index-nummer {
    position:absolute;
}


.siffra {
    font-size: 3em;
    padding-top:10px;

}
.container {
    min-height: 110vh;
    background-color: orange;
}

#klart {
    display:none;
}

.i{
    color:white;
    transition: color 1s;
}

.n{
    color:white;
    transition: color 1s;
}

#kodfält {
    display: inline-block;
    text-align: left;
    background-color: lightgrey;
    padding: 1em;
    font-family: 'Courier New', monospace;
}

#tempfält {
position: relative;
width:100%;
background-color: black;

}

#temp-ram {
    border-radius: 30px;
    background-color: #bb0;
    border-style: solid;

    height: 80px;
    width: 80px;

    position:absolute;
    color:black;

}

#i-pos {
    position: absolute;
    top: 200px;
    color: black;
    left:125px;
    font-family: "Times New Roman", Times, serif;


}
#j-pos {
    position: absolute;
    top:300px;
    color: red;
    left:125px;
    display: none;
}#min-pos {
    position: absolute;
    top:315px;
    color: red;
    left:125px;
    display: none;
}

</style>
